import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useLang } from "@/common/Contexts/LanguageContext";
var CtaArrow = function CtaArrow(_ref) {
  var lang = _ref.lang;
  return lang === "ar" ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-back-ios",
    className: "text-primary-new",
    width: 4,
    height: 4
  }) : /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios",
    className: "text-primary-new",
    width: 4,
    height: 4
  });
};
var OilProductCardHeader = function OilProductCardHeader(_ref2) {
  var logo = _ref2.logo,
    title = _ref2.title,
    subTitle = _ref2.subTitle,
    ctaLink = _ref2.ctaLink,
    ctaLabel = _ref2.ctaLabel;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "md:hidden flex items-start gap-2 mb-5"
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: title || "oil product",
    loading: "eager",
    className: "flex-shrink-0 w-[76px] h-12 object-contain"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col text-start min-w-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "text-base text-[#6B7EA5] font-medium leading-6"
  }, title), ctaLink && /*#__PURE__*/React.createElement("div", {
    role: "link",
    onClick: function onClick() {
      window.location.href = ctaLink;
    },
    className: "flex items-center gap-1 text-sm text-[#0d0db5] font-semibold cursor-pointer whitespace-nowrap flex-shrink-0 hover:underline"
  }, /*#__PURE__*/React.createElement("span", null, ctaLabel), /*#__PURE__*/React.createElement(CtaArrow, {
    lang: lang
  }))), subTitle && /*#__PURE__*/React.createElement("a", {
    href: ctaLink,
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-base font-bold leading-6 text-[#00143C] m-0"
  }, subTitle)))), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex items-center justify-between mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    loading: "eager",
    alt: title || "oil product",
    className: "object-contain rounded-lg flex-shrink-0 w-20 h-auto"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "text-base text-[#6B7EA5] font-medium mb-0.5"
  }, title), subTitle && /*#__PURE__*/React.createElement("a", {
    href: ctaLink,
    className: "no-underline"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-bold text-[#00143C]"
  }, subTitle)))), ctaLink && /*#__PURE__*/React.createElement("div", {
    role: "link",
    onClick: function onClick() {
      window.location.href = ctaLink;
    },
    className: "flex items-center gap-0.5 text-sm text-primary-new font-semibold cursor-pointer whitespace-nowrap flex-shrink-0 hover:underline"
  }, /*#__PURE__*/React.createElement("span", null, ctaLabel), /*#__PURE__*/React.createElement(CtaArrow, {
    lang: lang
  }))));
};
export default OilProductCardHeader;